import { render } from "./ProductTypeIcons.vue?vue&type=template&id=252a5f19"
import script from "./ProductTypeIcons.vue?vue&type=script&lang=js"
export * from "./ProductTypeIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__